import { action, payload } from "ts-action";
import { getPromotionsAction } from "../../../constants";
import { IPromocode } from "../../../types";

export const getPromotions = action(getPromotionsAction.requested, payload<{ page: number, per_page: number, is_exclusive?: boolean }>());
export const getPromotionsSuccess = action(getPromotionsAction.fulfilled, payload<{ data: IPromocode[], hasMore: boolean }>());
export const getPromotionsFailure = action(getPromotionsAction.rejected, payload<Error>())